import { render, staticRenderFns } from "./WelcomeLayout.vue?vue&type=template&id=c267d206&"
import script from "./WelcomeLayout.vue?vue&type=script&lang=js&"
export * from "./WelcomeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c267d206')) {
      api.createRecord('c267d206', component.options)
    } else {
      api.reload('c267d206', component.options)
    }
    module.hot.accept("./WelcomeLayout.vue?vue&type=template&id=c267d206&", function () {
      api.rerender('c267d206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/WelcomeLayout.vue"
export default component.exports